import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateNotificationsSettingsAction } from 'Shared/actions/user';

import DayPicker from 'Shared/components/DayPicker/DayPicker';

import { WpContainer, WpContainerBody, WpContainerHeader } from 'Wpds/components/container';

function UserNotificationNotDisturb() {
  const dispatch = useDispatch();
  const notificationSettings = useSelector(state => state.user.notificationSettings);
  const choosenDays = notificationSettings.doNotDisturb;
  const handleDayClick = day => {
    const values = choosenDays.includes(day)
      ? choosenDays.filter(choosenDay => choosenDay !== day)
      : [...choosenDays, day];
    const updatedValues = { ...notificationSettings, doNotDisturb: values };
    dispatch(updateNotificationsSettingsAction(updatedValues));
  };

  return (
    <WpContainer>
      <WpContainerHeader>
        <h5>Do not disturb</h5>
      </WpContainerHeader>
      <WpContainerBody>
        <p className="mb-4">Do not send me ANY notifications on the following days:</p>
        <DayPicker byNumber choosenDays={choosenDays} onDayClick={handleDayClick} variant="red" />
      </WpContainerBody>
    </WpContainer>
  );
}

export default UserNotificationNotDisturb;
